import React, { useEffect, useState } from 'react'
import './UserMapping.css'
import { Button, Select, Space, Table, message,Input,DatePicker, Switch, Tooltip } from 'antd'
import axios from 'axios';
import { BaseUrl, FrontendUrl } from '../../Constants/Constants';
import { EditOutlined } from '@mui/icons-material';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import Lottie from 'lottie-react';
import loaderJson from '../../LottieAnimation/wave-loader.json';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {
  generateUserCourseTemplate,
  generateManagerCourseTemplate
} from '../CourseEmailTemplates'; 
import { calculateMidDate } from '../MidDateCalcutation';
import { findAllByDisplayValue } from '@testing-library/react';

const { Option, OptGroup } = Select;


const userColumn = [
    {
        title: 'User Name',
        dataIndex: 'username',
        key: 'username',
        align: 'center',
    },
    {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        align: 'center',
    },

       {
        title: 'Level',
        dataIndex: 'level',
        key: 'level',
        align: 'center',
    },
       {
        title: 'Domain',
        dataIndex: 'domain',
        key: 'domain',
        align: 'center',
    },
       {
        title: 'Department',
        dataIndex: 'department',
        key: 'department',
        align: 'center',
    },
    {
  title: 'New Batch',
  dataIndex: 'new_batch',
  key: 'new_batch',
  align: 'center',
  render: (value) => value ? '✅' :'❌',
}


];

const nonLinkedColumn = [
    {
        title: 'User Name',
        dataIndex: 'username',
        key: 'username',
        align: 'center',
    },
    {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        align: 'center',
    },

     {
        title: 'Level',
        dataIndex: 'level',
        key: 'level',
        align: 'center',
    },
       {
        title: 'Domain',
        dataIndex: 'domain',
        key: 'domain',
        align: 'center',
    },
       {
        title: 'Department',
        dataIndex: 'department',
        key: 'department',
        align: 'center',
    },
    {
  title: 'New Batch', 
  dataIndex: 'new_batch',
  key: 'new_batch',
  align: 'center',
  render: (value) => value ? '✅' :'❌',
}
];

const UserMapping = () => {

    const { courseId } = useParams();
    const navigate = useNavigate();
    const courseIds = courseId.split(',');


    const [teamOption, setTeamOption] = useState([]);
    const [selectedTeam, setSelectedTeam] = useState('');
    const [nonLinkedUserTeam, setNonLinkedUserTeam] = useState('');
    const [userData, setUserData] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [ linkedRowKeys, setLinkedRowKeys ] = useState([]);
    const [nonLinkedData, setNonLinkedData] = useState([]);
    const [searchLinked, setSearchLinked] = useState('');
    const [searchNonLinked, setSearchNonLinked] = useState('');
    const[CourseData,setCourseData] = useState([]);
    const[CourseEmailData, setCourseEmailData] = useState([]);
    const [deadlineDate, setDeadlineDate] = useState(null);
    const [emailSent, setEmailSent] = useState(false); 
    const [selectedUsersData, setselectedUsersData] = useState([])
    const[isLoading,setIsloading] = useState(false);
    const [showNewBatchOnly, setShowNewBatchOnly] = useState(false);

    const [filters, setFilters] = useState({
        level: '',
        domain: '',
        department: ''
       });

    const { Search } = Input;

    const isAssignDisabled =!deadlineDate;


    const handleCombinedSelect = (value) => {
  const [type, selectedValue] = value.split(':');
  setFilters(prev => ({ ...prev, [type]: selectedValue }));
};

    useEffect(() => {
        axios.get(`${BaseUrl}teams`,{withCredentials:true})
            .then((res) => {
                let teams = res.data.map((item) => {
                    let teamsObj = {
                        value: item.team_id,
                        label: item.Team_name
                    }
                    return teamsObj;
                })
                setTeamOption(teams);

            })
            .catch((err) => {
                console.log(err.message)
            })
    }, [])



const fetchAllCourseUsers = () => {
    const course = { courseId: courseIds };

    axios.post(`${BaseUrl}course-mapping/getAllUsers`, course, { withCredentials: true })
        .then((res) => {
            if (res.data.statuscode === 200) {
                let courseMappedUsers = res.data.data;
                let bodyUsers = { userId: courseMappedUsers };
            

                axios.post(`${BaseUrl}users/courseMappedUsers`, bodyUsers, { withCredentials: true })
                    .then((response) => {
                        let linkedUsersArray = response.data.data.linkedUsers || [];
                        let nonLinkedUsersArray = response.data.data.notLinkedUsers || [];

                        const formatUsers = (usersArray) => {
                            return usersArray.map((item) => ({
                                key: item.user_id,
                                username: item.username,
                                email: item.email,
                                level: item.level,
                                domain: item.domain,
                                department: item.department,
                                team: item.team_id?.Team_name || '',
                                new_batch: Boolean(item.new_batch)

                            }));
                        };

                        setUserData(formatUsers(linkedUsersArray));
                        setNonLinkedData(formatUsers(nonLinkedUsersArray));
                    })
                    .catch((err) => {
                        console.log(err.message);
                    });
            }
        })
        .catch((err) => {
            console.log(err.message);
        });
};

        useEffect(() => {
        let body = {
            course_id: courseId
        }
        axios
            .post(`${BaseUrl}courses/findOne`, body, {withCredentials:true})
            .then((res) => {
                console.log(res, "chanres")
                if (res.data.statuscode === 200)
                    setCourseData(res.data.data)
                console.log(CourseData,"courseData");
                
            })
            .catch((err) => {
                console.log(err)
            })
    }, [courseId])
    
    useEffect(() => {
        fetchAllCourseUsers();
    }, [selectedTeam, nonLinkedUserTeam])

    console.log(selectedTeam, 'filteredUsers')


    // Updated onSelectChange to properly handle all selected users data
    const onSelectChange = (newSelectedRowKeys, selectedRows) => {
        setSelectedRowKeys(newSelectedRowKeys);
        
        // Build complete selected users data from filteredNonLinkedData
        const completeSelectedData = filteredNonLinkedData.filter(user => 
            newSelectedRowKeys.includes(user.key)
        );
        setselectedUsersData(completeSelectedData);
    };

    const onLinkedSelectChange = (newSelectedRowKeys) => {
        console.log('selectedRowKeys changed: ', newSelectedRowKeys);
        setLinkedRowKeys(newSelectedRowKeys);
    };

    // Updated rowSelection for Unmapped Users table with proper pagination support
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        preserveSelectedRowKeys: true,
        selections: [
            Table.SELECTION_ALL,
            Table.SELECTION_INVERT,
            Table.SELECTION_NONE,
        ],
        onSelectAll: (selected, selectedRows, changeRows) => {
            if (selected) {
                // Select ALL users from filteredNonLinkedData (across all pages)
                const allKeys = filteredNonLinkedData.map(user => user.key);
                setSelectedRowKeys(allKeys);
                setselectedUsersData(filteredNonLinkedData);
            } else {
                // Deselect all
                setSelectedRowKeys([]);
                setselectedUsersData([]);
            }
        },
        getCheckboxProps: (record) => ({
            checked: selectedRowKeys.includes(record.key),
        }),
    };

    // Updated linkedrowSelection for Mapped Users table
    const linkedrowSelection = {
        selectedRowKeys: linkedRowKeys,
        onChange: onLinkedSelectChange,
        preserveSelectedRowKeys: true,
        selections: [
            Table.SELECTION_ALL,
            Table.SELECTION_INVERT,
            Table.SELECTION_NONE,
        ],
        onSelectAll: (selected, selectedRows, changeRows) => {
            if (selected) {
                // Select ALL users from filteredUserData (across all pages)
                const allKeys = filteredUserData.map(user => user.key);
                setLinkedRowKeys(allKeys);
            } else {
                // Deselect all
                setLinkedRowKeys([]);
            }
        },
        getCheckboxProps: (record) => ({
            checked: linkedRowKeys.includes(record.key),
        }),
    };

    const hasSelected = selectedRowKeys.length > 0;
    const linkedSelected = linkedRowKeys.length > 0;

    console.log(linkedRowKeys, 'linkedSelected')
    
    const handleRemove = () => {

        if (linkedSelected) {
            setIsloading(true);

            let body = {
                courseIds : courseIds, 
                userIds : linkedRowKeys
            }


            console.log(body, 'selectedBody')

            axios.post(`${BaseUrl}course-mapping/removeUserFromCourse`, body, {withCredentials:true})
                .then((res) => {
                    let response = res.data;
                    console.log(response,'DELETE')

                    if (response.success === true) {

                        message.success(`Removed ${linkedRowKeys.length} user`);
                        fetchAllCourseUsers();
                        setLinkedRowKeys([]);

                    }
                    else {
                        message.error(`Can't remove users!`)
                    }
                    setIsloading(false);


                })
                .catch((err) => {
                    console.log(err.message)
                    setIsloading(false);
                })
        }
        else {
            message.warning('Please select any user to Remove!')
        }
    }

    const [SendBulk, setSendBulk] = useState(false);
    const [SupportEmail, setSupportEmail] = useState('');

    useEffect(() => {
      axios
        .get(`${BaseUrl}email-service`, { withCredentials: true })
        .then((res) => {
          setSupportEmail(res.data[0].admin_email);
        })
        .catch((err) => {
          console.error('Error fetching admin email', err);
        });
    }, []);

    useEffect(() => {
      if (SendBulk && !emailSent) {
        const formatDate = (date) => {
          return new Date(date).toLocaleString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
            timeZoneName: 'short',
          });
        };

        const emailJobs = selectedUsersData.map((user) => ({
        email: user.email,
        courses: CourseEmailData,   
        frontendUrl: FrontendUrl,
        supportEmail: SupportEmail,
        }));

        console.log("Assignment email data:",emailJobs)
        axios
          .post(`${BaseUrl}email-service/bulk-upload`, emailJobs, { withCredentials: true })

          .then(() => {
            console.log(`Emails sent successfully to user `);
            setEmailSent(true);
            setSendBulk(false);
          })
          .catch((err) => {
            console.error(`Error sending email to user:`, err);
            setSendBulk(false);
          });
      }
    }, [SendBulk, emailSent, selectedUsersData, CourseEmailData, SupportEmail]);


    const handleAssign = () => {
        console.log(hasSelected, 'hasSelected')

        if (hasSelected) {
            setIsloading(true);
            const today = new Date().toISOString().split("T")[0]; 
            const remainderDate = calculateMidDate(today, deadlineDate);
            let body = selectedRowKeys.map((i) => (
                {
                    courseId: courseIds,
                    userId: i,
                    start_date: today,
                    remainderDate: remainderDate,
                    deadlineDate: deadlineDate,

                }
            ))

            console.log(body, 'selectedBody')

            axios.post(`${BaseUrl}course-mapping/create`, body, {withCredentials:true})
                .then((res) => {

                    let response = res.data;

                    if (response.statuscode === 200) {
                        setCourseEmailData(response.data);
                        let updateBody = [{
                            courseId: courseId,
                            teamId: selectedTeam
                        }]

                        axios.post(`${BaseUrl}courses/update`, updateBody, {withCredentials:true})

                            .then((res) => {
                                console.log(res.data, 'updateCourse');
                                message.success(`Course assigned to ${selectedRowKeys.length} user`);
                                fetchAllCourseUsers();
                                setSelectedRowKeys([]);
                                setselectedUsersData([]);
                                setEmailSent(false);
                                setSendBulk(true);
                                setIsloading(false);
                            })
                            .catch((err) => {
                                console.log(err.message);
                                message.error(`Error Updating the team to the course!`);
                                setIsloading(false);
                            })

                    }
                    else {
                        message.error(`Can't assign courses!`)
                        setIsloading(false);
                    }


                })
                .catch((err) => {
                    console.log(err.message)
                    setIsloading(false);
                })
        }
        else {
            message.warning('Please select any user to assign course!')
        }
    }

    const applyFilters = (data) => {
      return data.filter(user => {
        const matchesLevel = !filters.level || user.level === filters.level;
        const matchesDomain = !filters.domain || user.domain === filters.domain;
        const matchesDepartment = !filters.department || user.department === filters.department;
        const matchesNewBatch = !showNewBatchOnly || user.new_batch === true;

        return matchesLevel && matchesDomain && matchesDepartment && matchesNewBatch;
      });
    };

    const filteredUserData = applyFilters(userData).filter(user =>
      user.username.toLowerCase().includes(searchLinked.toLowerCase()) ||
      user.email.toLowerCase().includes(searchLinked.toLowerCase())
    );

    const filteredNonLinkedData = applyFilters(nonLinkedData).filter(user =>
      user.username.toLowerCase().includes(searchNonLinked.toLowerCase()) ||
      user.email.toLowerCase().includes(searchNonLinked.toLowerCase())
    );

    console.log(selectedTeam, 'selectedUserId')

    return (
        
        <div className='userMappingMain'>
            {isLoading && (
            <div style={{ position: 'fixed', top: 0, left: 0, height: '100vh', width: '100vw', backgroundColor: 'rgba(255,255,255,0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }}>
                <Lottie animationData={loaderJson} loop={true} style={{ height: 200 }} />
            </div>
            )}

            <p className='back'>
                <span onClick={(e) => navigate(`/assigncourse`)} style={{ color: '#4096FF', textDecoration: "underline" }}>
                    /Courses
                </span>
                <span>
                    <ArrowForwardIosIcon className='arrow' />
                </span>
            </p>

            <h2>Assign Course</h2>

            <div className='selectAndAssignButton'>

                <div style={{fontSize:"500", fontWeight:"bold"}}>Filter By</div>
    <div className="filter-row">
    <Select
            placeholder="Select Level"
            style={{ marginRight:5 }}
            onChange={(value) => setFilters((prev) => ({ ...prev, level: value || '' }))}
            value={filters.level || undefined}
            allowClear
            >
            <Option value="Executive Management">Executive Management</Option>
            <Option value="Core Team">Core Team</Option>
            <Option value="Entry Level">Entry Level</Option>
            <Option value="VRAs">VRAs</Option>
            </Select>

            <Select
            placeholder="Select Domain"
            style={{ marginRight:5 }}
            onChange={(value) => setFilters((prev) => ({ ...prev, domain: value || '' }))}
            value={filters.domain || undefined}
            allowClear
            >
            <Option value="Marketing">Marketing</Option>
            <Option value="Tech">Tech</Option>
            <Option value="HR">HR</Option>
            <Option value="IT">IT</Option>
            <Option value="Admin">Admin</Option>
            <Option value="Compliance">Compliance</Option>
            <Option value="QA">QA</Option>
            <Option value="Procurement">Procurement</Option>
            <Option value="All Managers">All Managers</Option>
            <Option value="IT Security">IT Security</Option>
            </Select>

            <Select
            placeholder="Select Department"
            style={{ marginRight:5 }}
            onChange={(value) => setFilters((prev) => ({ ...prev, department: value || '' }))}
            value={filters.department || undefined}
            allowClear
            >
            <Option value="Development">Development</Option>
            <Option value="Testing">Testing</Option>
            <Option value="Devops">Devops</Option>
            <Option value="Product Management">Product Management</Option>
            <Option value="Business Analysis">Business Analysis</Option>
            </Select>


              <div style={{display:"flex", paddingTop: '10px'}}>
        <Switch
  checked={showNewBatchOnly}
  onChange={(checked) => setShowNewBatchOnly(checked)}
  style={{ marginRight: 10 }}
/>
<span>Show New Batch Users</span>
    </div>


    </div>

  <div className="dates-buttons-row">
    <div style={{fontSize:"500", fontWeight:"bold"}}> Select  Deadline Date
    <div className="dates-section">
      <Tooltip title='This date will be the last available date of the  selected course for users.'>
            <DatePicker 
        onChange={(date, dateString) => setDeadlineDate(dateString)} 
        placeholder="Select Deadline Date" 
        needConfirm 
      />
      </Tooltip>
    </div>
  
    </div>
    
    <div  className="buttons-section">
    <Button 
      className='addCourseButton'
      onClick={handleAssign}
      disabled={!deadlineDate}
    >
      Assign Users
    </Button>
    <Button className='addCourseButton' onClick={handleRemove}>
      Remove
    </Button>
  </div>
  </div>

            </div>
            <div className='Tableset'>
            <div>
            <h2>Mapped Users</h2>
            <Search
                        placeholder="Search Users"
                        onChange={e => setSearchLinked(e.target.value)}
                        style={{ marginBottom: 16, width: 300 }}
                    />

            <Table rowSelection={linkedrowSelection} columns={userColumn} dataSource={filteredUserData} />
            <h3
                style={{
                    marginLeft: 8,
                }}
            >
                {linkedSelected ? `Selected ${linkedRowKeys.length} user` : ''}
            </h3>
            <div className='selectAndAssignButton'>
            </div>
            </div>
            <div>
            <h2>Unmapped Users</h2>
            <Search
                        placeholder="Search Users"
                        onChange={e => setSearchNonLinked(e.target.value)}
                        style={{ marginBottom: 16, width: 300 }}
                    />
            <Table rowSelection={rowSelection} columns={nonLinkedColumn} dataSource={filteredNonLinkedData} />
            <h3
                style={{
                    marginLeft: 8,
                }}
            >
                {hasSelected ? `Selected ${selectedRowKeys.length} user` : ''}
            </h3>
            </div>
            </div>
            
        </div>
    )
}


export default UserMapping;